
export const menuOptions = {
    maps:0,
    documents:1
}

export const generalQueriesMapsMockup = [
    {
        title: 'Zona Nordeste :- Cabarete',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-nordeste-cabarete.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-nordeste-cabarete.jpg'
    },
    {
        title: 'Zona Nordeste :- Isabela - Luperon',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-nordeste-isbela-luperon.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-nordeste-isbela-luperon.jpg'
    },
    {
        title: 'Zona Nordeste :- San Juan - Cabrera',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-nordeste-san-juan-cabrera.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-nordeste-san-juan-cabrera.jpg'
    },
    {
        title: 'Zona Nordeste :- Costa Puerto Plata',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-nordeste-costa-puerto-plata.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-nordeste-costa-puerto-plata.jpg'
    },
    {
        title: 'Zona Este :- Nisibon - Maco',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-este-nisibon-macao.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-este-nisibon-macao.jpg'
    },
    {
        title: 'Zona Este :- Boca Anamuya - Caleton Hondo',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-este-boca-anamuya-caleton-hondo.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-este-boca-anamuya-caleton-hondo.jpg'
    },
    {
        title: 'Zona Este :- Bayahibe - La Romana',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-este-bayahibe-romana.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-este-bayahibe-romana.jpg'
    },
    {
        title: 'Zona Sur :- Barahona - Saladilla',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-sur-barahona-saladilla.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-sur-barahona-saladilla.jpg'
    },
    {
        title: 'Zona Sur :- Barahona - Oviedo',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-sur-barahona-oviedo.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-sur-barahona-oviedo.jpg'
    },
    {
        title: 'Zona Sur :- Lago Enriquillo',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-sur-lago-enriquillo.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-sur-lago-enriquillo.jpg'
    },
    {
        title: 'Zona Centro Norte :- Jarabacoa - Constanza',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-zona-centro-norte-jarabacoa-constanza.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-zona-centro-norte-jarabacoa-constanza.jpg'
    },
    {
        title: 'Costa Metropolitana',
        previewURL: 'https://www.dpp-mitur.gob.do/a/i/tn-costa-metropolitana.jpg',
        imageURL: 'https://www.dpp-mitur.gob.do/a/i/img-costa-metropolitana.jpg'
    },
]

export const generalQueriesDocumentsMockup = [
    {
        id:1,
        title: 'Leyes',
        documents:[
            {
                documentTitle:"Ley 16-95 Sobre Inversión Extranjera",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-16-95-sobre-Inversion-Extranjera.pdf"
            },
            {
                documentTitle:"Ley 24-98",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-24-98.pdf"
            },
            {
                documentTitle:"Ley 84-79 - Ley Orgánica de Turismo que modifica la Ley",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-84-79-Ley-Organica-Turismo-modifica-Ley-541-69.pdf"
            },
            {
                documentTitle:"Ley 84-79 - Ley que modifica la Ley 541-69",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-84-79-Ley-que-modifica-Ley-541-69.pdf"
            },
            {
                documentTitle:"Ley 158-01 - Ley de Fomento al Desarrollo Turístico con Modificaciones de la Ley 184-02 y 318-04",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-158-01-Ley-Fomento-Desarrollo-Turistico-con-Modificaciones-Ley-184-02-y-318-04.pdf"
            },
            {
                documentTitle:"Ley 202-04 de Areas Protegidas",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-202-04-Areas-Protegidas.pdf"
            },
            {
                documentTitle:"Ley 351-67",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-351-67.pdf"
            },
            {
                documentTitle:"Ley 541-69 - Ley orgánica de turismo",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-541-69-Ley-organica-Turismo.pdf"
            },
            {
                documentTitle:"Ley 542-69 - Ley orgánica de la Corporación de Fomento de la Industria Hotelera y Desarrollo del Turismo",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-542-69-Ley-organica-corporacion-fomento-industria-hotelera-turismo.pdf"
            },
            {
                documentTitle:"Ley 184-02 que introduce modificaciones a la Ley 158-01",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/leyes/Ley-184-02-introduce-modificaciones-Ley-158-01.pdf"
            },
        ]
    },
    {
        id:2,
        title: 'Decretos',
        documents:[
            {
                documentTitle:"Decreto 847-09",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-847-09.pdf"
            },
            {
                documentTitle:"Decreto 221-06 establece parámetros de construcción de edificios en el Malecón de Puerto Plata",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-221-06-establece-parametros-construccion-edif-en-Malecon-de-Pto-Pta.pdf"
            },
            {
                documentTitle:"Decreto 336-05 crea el CEIZTUR",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-336-05-crea-el-CEIZTUR.pdf"
            },
            {
                documentTitle:"Decreto 402-05 Modifica Decreto 336-05",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-402-05-modifica-Decreto-336-05.pdf"
            },
            {
                documentTitle:"Decreto 452-05 Reglamento CEIZTUR",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-452-05-reglamento-CEIZTUR.pdf"
            },
            {
                documentTitle:"Decreto 559-06 sobre Certificación uso de los Suelos por Turismo",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-559-06-sobre-certificacion-uso-suelos-por-turismo.pdf"
            },
            {
                documentTitle:"Decreto 599-06",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-599-06.pdf"
            },
            {
                documentTitle:"Decreto-687-05 CEIZTUR y los Rellenos Sanitarios",
                documentURL:"https://www.dpp-mitur.gob.do/a/d/decretos/Decreto-687-05-CEIZTUR-y-los-rellenos-sanitarios.pdf"
            },
        ]
    },
    {
        id:3,
        title: 'Resoluciones',
        documents:[
            {
                documentTitle:"Resolución No. 01-2019",
                documentURL:"https://confotur.mitur.gob.do/wp-content/uploads/2021/01/RESOLUCION-NO.-01-2019-DE-SERVICIOS.pdf"
            },
            {
                documentTitle:"Resolución No. 100-2020",
                documentURL:"https://confotur.mitur.gob.do/wp-content/uploads/2021/01/RESOLUCION-NO.-100-2020-QUE-OTORGA-UNA-PRORROGA-DE-UN-1-AN%CC%83O-A-PLAZO-DE-3-TRES-AN%CC%83OS-DE-CONSTRUCCION.pdf"
            },
            {
                documentTitle:"Resolución No. 166-2020",
                documentURL:"https://confotur.mitur.gob.do/wp-content/uploads/2021/01/RESOLUCION-NO.-166-2020-MODIFICATORIA-RES.-100-2020-PRORROGA-GENERAL-A-LOS-TRES-AA%CC%83%E2%80%98OS-DE-CONSTRUCCION.pdf"
            },
            {
                documentTitle:"Resolución No. 196-2019",
                documentURL:"https://confotur.mitur.gob.do/wp-content/uploads/2021/01/RESOLUCION-NO.-196-2019-QUE-ESTABLECE-LA-OBLIGATORIEDAD-DE-INSTALACION-D....pdf"
            },
            {
                documentTitle:"Resolución No. 28-2018",
                documentURL:"https://confotur.mitur.gob.do/wp-content/uploads/2021/01/RESOLUCION-NO.-28-2018-REQUISITOS-SOLICITUD-EXONERACION-MATERIALES.pdf"
            },
            {
                documentTitle:"Resolución No. 49-2014",
                documentURL:"https://confotur.mitur.gob.do/wp-content/uploads/2021/01/RESOLUCION-NO.-49-2014-TURISMO-DE-SALUD.pdf"
            },
            {
                documentTitle:"Resolución 01-2007",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-01-2007.pdf"
            },
            {
                documentTitle:"Resolución 11-2000",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-11-2000.pdf"
            },
            {
                documentTitle:"Resolución 15-2005",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-15-2005.pdf"
            },
            {
                documentTitle:"Resolución 28-2006",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-28-2006.pdf"
            },
            {
                documentTitle:"Resolución 63-2005",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-63-2005.pdf"
            },
            {
                documentTitle:"Resolución 68-2005",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-68-2005.pdf"
            },
            {
                documentTitle:"Resolución 99-2005",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-99-2005.pdf"
            },
            {
                documentTitle:"Resolución 107-2004",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-107-2004.pdf"
            },
            {
                documentTitle:"Resolución 154-2005",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-154-2005.pdf"
            },
            {
                documentTitle:"Resolución 200-2005",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-200-2005.pdf"
            },
            {
                documentTitle:"Resolución 211-2005",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resolucion-211-2005.pdf"
            },
            {
                documentTitle:"Resoluciones Licencia de operación de hoteles",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resoluciones_licencia-de-operacion-de-hoteles.pdf"
            },
            {
                documentTitle:"Resoluciones Licencia de operación de restaurantes",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Resoluciones-licencia-de-opercacion-de-restaurantes.pdf"
            },
        ]
    },
    {
        id:4,
        title: 'Reglamentos',
        documents:[
            {
                documentTitle:"Reglamento 1125 01 de aplicación Ley-158-01.pdf",
                documentURL:"https://www.dpp-mitur.gob.do//a/d/resoluciones/Reglamento-1125-01-de-aplicacion-Ley-158-01.pdf"
            },
        ]
    },
]